export default __webpack_public_path__ + "static/media/downloading.0260bdbb.gif";